import { mapGetters, mapActions } from 'vuex';
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "ShowUser",
  components: {
  },
  data() {
    return {
      submitted: false,
      saisieEnCours: false,
      user: {},
      email: '',
      emailState: null,
      codeSent: false,
    }
  },

  validations() {
    return {
      user: {
        telephone: { required },
        entreprise_nom: {
          required: requiredIf(function (nestedModel) {
            return this.auth.permissions && this.auth.permissions.find(perm => perm.name == 'access users')
          })
        }
      },

    }
  },

  computed: {
    ...mapGetters([
      'auth',
    ]),

  },

  watch: {
    "auth.user": {
      immediate: true,
      handler(user) {
        this.user = {...user}
      }
    }
  },

  methods: {

    ...mapActions([
      'setUser', 'sendValidationCode'
    ]),

    validateEmail(bvModalEvent) {
      if(!this.codeSent) {
        this.emailState = this.$refs.emailForm.checkValidity()
        if(this.emailState) {
          this.sendValidationCode(this.email).then(() => this.codeSent = true)
        }
        bvModalEvent.preventDefault()
      }
    },

    updateUser() {
      this.submitted = true;
      this.auth.user.entreprise_nom = this.entrepriseSelect;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }

      this.setUser(this.user).then(response => {
        this.$toasted.show("Enregistrement réalisé", {
          icon: {
            name: 'user-check',
          },
          theme: "outline",
          position: "bottom-center",
          duration : 2000
       });
      }).catch(error => {
        this.$toasted.show("L'enregistrement n'a pas pu être réalisé, des données sont sûrement incorrectes.", {
          type : 'error',
          icon: {
            name: 'times',
          },
          position: "bottom-center",
          duration : 2000
       });

      });
    },

  },

}